import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  token?: string | null;
  refreshToken?: string | null;
  user?: string | null;
  roles?: string | null;
  expires?: string | null;
}

const initialState: UserState = {
  token: null,
  refreshToken: null,
  user: null,
  roles: null,
  expires: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state: any, action: PayloadAction<UserState>) => { 
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.user = action.payload.user;
      state.roles = action.payload.roles;
      state.expires = action.payload.expires;
    },
    clearUser: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.user = null;
      state.roles = null;
      state.expires = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
